import { FC } from 'react';
import { FloatButton } from 'antd';
import { BackTopProps } from 'antd/lib/float-button/interface';

export type ProBackTopProps = BackTopProps;

const Index: FC<ProBackTopProps> = props => {
  return (
    <FloatButton.BackTop {...props} />
  );
};

export default Index;